import React from 'react';
import { SectionWrapper, FadeIn, CTAButton } from './Shared';
export const CTABreak = () => {
  return <SectionWrapper className="bg-sage-50 !py-8 md:!py-16" data-id="element-38">
      <div className="text-center max-w-2xl mx-auto" data-id="element-39">
        <FadeIn data-id="element-40">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-sage-900 mb-8" data-id="element-41">
            ¿Lista para empezar tu transformación?
          </h2>
          <CTAButton data-id="element-42">👉 Acceder a Deshinchate ahora</CTAButton>
        </FadeIn>
      </div>
    </SectionWrapper>;
};